module.exports = function() {
  return new Worker(__webpack_public_path__ + "99737acc0de7e8e880b3.worker.js");
};